import {AUTO_LOGIN} from '/enum/biometrics.enum';
import {createPromisedAction} from '/util/action.util';

export const setAutoLoginState = createPromisedAction(AUTO_LOGIN);
